import * as React from 'react'

import { GlobalEvents } from '../../../Other/GlobalEvents'
import { TestableInterface } from '../interfaces/TestableInterface'
import { makeTranslatable, TranslatableType } from '../interfaces/Translatable'
import { ValidatableInterface } from '../interfaces/ValidatableInterface'
import { formatRequiredIndicator } from '../Required/Required'
import { RequiredInterface } from '../Required/RequiredInterface'
import '../SelectInput/SelectInput.scss'

export type OpeningDirection = 'up' | 'down'

export interface SelectInputProps extends TestableInterface, ValidatableInterface, RequiredInterface {
  className?: string
  label?: TranslatableType
  value: any | any[]
  selectPlaceholder?: string
  onBlur?: (value: string) => void
  labelPosition?: 'left' | 'top'
  borderless?: boolean
  openDirection?: OpeningDirection
  disabled?: boolean
  tail?: JSX.Element
}

export interface SelectInputState {
  menuOpen: boolean
  index: number
}

export default class CustomSelectInput extends React.Component<SelectInputProps, SelectInputState> {
  constructor(props: SelectInputProps) {
    super(props)

    const index = 0
    this.state = {
      menuOpen: false,
      index,
    }
  }

  public static defaultProps: SelectInputProps = {
    value: null,
    openDirection: null,
  }

  // just close the list div
  private handleOnBlur() {
    this.setState({ menuOpen: false })
  }

  private e
  public componentDidMount() {
    this.e = GlobalEvents.Click((e) => {
      this.handleOnBlur()
    })
  }

  public componentDidUpdate() {
    window.requestAnimationFrame(() => {
      if (this.state.menuOpen) {
        this.checkMenuOpeningDirection()
      }
    })
  }

  public componentWillUnmount() {
    GlobalEvents.unBind(this.e)
  }

  private checkMenuOpeningDirection() {
    // Hackety hack to open menu upwards if it would go over the bottom edge of content div.
    // This is mostly for modals that may be smaller and/or scrollable.
    // Requires a parent div at some level with className 'content'
    const menuDiv = document.getElementById(`menuDiv-${this.props.automation}`)
    if (menuDiv && !this.props.openDirection) {
      let parentDiv = menuDiv.parentElement
      while (parentDiv.parentElement) {
        parentDiv = parentDiv.parentElement
        if (parentDiv.className.indexOf('content') >= 0) {
          if (menuDiv.getBoundingClientRect().bottom > parentDiv.getBoundingClientRect().bottom) {
            menuDiv.className = 'select-menu up'
          }
          break
        }
      }
    }
  }

  private static scrollSelectedToView(automation) {
    const selected = document.getElementsByClassName(`${automation}-selected`)
    if (selected && selected[0]) {
      selected[0].scrollIntoView({ block: 'nearest', behavior: 'auto' })
    }
  }

  private openMenu() {
    const index = 0
    this.setState({
      menuOpen: true,
      index,
    })
    this.checkMenuOpeningDirection()
    setTimeout(() => CustomSelectInput.scrollSelectedToView(this.props.automation), 100)
  }

  public render(): JSX.Element {
    const classes = ['CustomSelectInput', 'SelectInput', 'Controlled', 'Input']
    if (this.props.className) {
      classes.push(this.props.className)
    }
    const required = formatRequiredIndicator(this.props)
    if (this.props.labelPosition && this.props.labelPosition === 'top') {
      classes.push('LabelOnTop')
    }
    if (this.props.borderless) {
      classes.push('Borderless')
    }
    if (this.props.invalid) {
      classes.push('invalid')
    }
    if (this.props.disabled) {
      classes.push('SelectInput--disabled')
    }
    let label = null
    if (this.props.label) {
      label = (
        <span data-automation={this.props.automation + '-label'} className="Label">
          {makeTranslatable(this.props.label)}
          {required}
        </span>
      )
    }

    let menu = null
    if (this.state.menuOpen) {
      const direction = this.props.openDirection || ''
      menu = (
        <div
          className={`select-menu ${direction}`}
          id={`menuDiv-${this.props.automation}`}
          onClick={(e) => {
            GlobalEvents.prevent(this.e)
            return false
          }}
        >
          {this.props.children}
        </div>
      )
      classes.push('menuOpen')
    }

    this.checkMenuOpeningDirection()

    return (
      <div className={classes.join(' ')} data-automation={this.props.automation} data-value={this.props.value}>
        {label}
        <div className="select Controlled">
          <div
            className="selected-value"
            onClick={(e) => {
              if (this.props.disabled) {
                return false
              }
              if (!this.state.menuOpen) {
                this.openMenu()
              } else {
                this.setState({ menuOpen: false })
              }
              GlobalEvents.prevent(this.e)
              return false
            }}
            tabIndex={0}
          >
            <span className="selected-value">
              {this.props.value !== null && this.props.value}
              {!this.props.value && this.props.selectPlaceholder && (
                <span className="placeholder">{this.props.selectPlaceholder}</span>
              )}
            </span>
            <span className="arrow" />
          </div>
          {menu}
        </div>
        {this.props.tail ? this.props.tail : null}
      </div>
    )
  }
}
